export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_SUCCESSFUL = "LOGIN_USER_SUCCESSFUL";
export const LOGIN_USER_FAILED = "LOGIN_USER_FAILED";
export const LOGIN_USER_NOT_FOUND = "LOGIN_USER_NOT_FOUND"; 
export const LOGIN_RESET_STATE = "LOGIN_RESET_STATE"; 
